<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  @if (showEmptyOption()) {
    <nb-option [value]="null">Alle</nb-option>
  }
  <nb-option [value]="Status.Pending">
    In Bearbeitung
  </nb-option>
  <nb-option [value]="Status.Accepted">
    Akzeptiert
  </nb-option>
  <nb-option [value]="Status.Rejected">
    Abgelehnt
  </nb-option>
</nb-select>
